import React, { FC, useState, useEffect, useMemo } from "react";
import { Button, Collapse, message, Modal, Popconfirm, Space } from "antd";

import {
  PlusCircleOutlined,
  DeleteOutlined,
  SettingOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import {
  IMenuSettingModel,
  IUpdatedMenuSettingModel,
} from "states/menu-setting/menu-setting.models";
import { MenuSettingChildrenModal } from "./menu-modal-chilren";
import { MenuSettingItemList } from "./menu-item-list";
import {
  getMenuSettingById,
  removeMenuSetting,
  updateMenuSetting,
} from "states/menu-setting/menu-setting.api";
import { t, CoreResource } from "shared/plugins/localization";
import { Cancel, DefaultErrorMessage, MenuText, OkText, QuestionRemove, Sort, UpdateDataSuccessfully } from "shared/constants/define-localization";
import { Sortable, SortItemModel } from "shared/components/sortable/sortable";
import { nanoid } from "@reduxjs/toolkit";
import { LanguageSelector } from "shared/components/language-selector";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "app.store";

interface IMenuSettingItemProps {
  isRootMenu: boolean;
  menuItem: IMenuSettingModel;
  onSuccess: () => void;
}
const { Panel } = Collapse;
export const MenuSettingItem: FC<IMenuSettingItemProps> = (props) => {
  const { isRootMenu, menuItem, onSuccess } = props;
  const clientLanguages = useSelector(
    (state: RootState) => state.localization.clientLanguages,
    shallowEqual
  );
  const [currentLanguage, setCurrentLanguage] = useState<string>();
  const [model, setModel] = useState<IMenuSettingModel>(
    {} as IMenuSettingModel
  );
  const [currentModel, setCurrentModel] = useState<IMenuSettingModel>(
    {} as IMenuSettingModel
  );
  const [isModal, setModal] = useState(false);
  const [isUpdate, setUpdate] = useState(false);
  const [isUpdateSort, setIsUpdateSort] = useState(false);
  const onRemoveBtn = async (id: number) => {
    try {
      removeMenuSetting(id);
      onSuccess();
      message.success("Cập nhật thành công");
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
        "Lỗi hệ thống"
      );
    }
  };
  const genExtra = (id: number) => (
    <Space>
      {isRootMenu && (
        <LanguageSelector
          width={140}
          onClick={(event) => {
            event.stopPropagation();
          }}
          onChange={async (value) => {
            const res = await getMenuSettingById(menuItem.id ?? 0, value);
            if (!res.data.name) {
              Modal.confirm({
                title: "Thông báo",
                content:
                  "Nội dung chưa được khởi tạo cho ngôn ngữ này, bạn có muốn khởi tạo?",
                onOk: () => {
                  setCurrentLanguage(value);
                  onUpdate(model,value);
                },
              });
              return;
            } else {
              setCurrentLanguage(value);
              setCurrentModel(res.data);
            }
          }}
          selectedCode={currentLanguage}
        />
      )}
      <Button
        type="primary"
        onClick={(event) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
          setModal(true);
          setUpdate(false);
          setModel({} as IMenuSettingModel);
        }}
        icon={<PlusCircleOutlined />}
      ></Button>
      <Popconfirm
        placement="topLeft"
        title={"Bạn có muốn xóa không ?"}
        onCancel={(event: any) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
        }}
        onConfirm={() => onRemoveBtn(id)}
        okText={"Đồng ý"}
        cancelText={"Hủy"}
      >
        <Button
          type="primary"
          danger
          onClick={(event) => {
            // If you don't want click extra trigger collapse, you can prevent this:
            event.stopPropagation();
          }}
          icon={<DeleteOutlined />}
        ></Button>
      </Popconfirm>
      <Button
        onClick={(event) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
          if (model?.data?.length > 0) {
            setIsUpdateSort(true);
          }
        }}
        icon={<OrderedListOutlined />}
      ></Button>
      <Button
        onClick={async (event) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
          //handleToggleModal();
          setModal(true);
          setModel({ ...currentModel });
          setUpdate(true);
        }}
        icon={<SettingOutlined />}
      ></Button>
    </Space>
  );
  const onUpdate = async (model: IMenuSettingModel, langCode?: string) => {
    try {
      var resovledCode = (langCode !== undefined ? langCode+"-": "");
      let payload: IUpdatedMenuSettingModel = {
        ...model,
        id: model.id ?? 0,
        name: resovledCode  + model.name,
        slug: model.slug,
        images: model.images,
        sort: model.sort,
        data: model.data,
        extensionFields: model.extensionFields,
        menuType: model.menuType,
      };
      await updateMenuSetting(payload, langCode??currentLanguage);
      setCurrentModel({...payload});
      message.success("Cập nhật thành công");
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
        "Lỗi hệ thống"
      );
    }
  };
  const onAddMenuChildren = (menuModel: IMenuSettingModel) => {
    let modelTemp = { ...currentModel };
    menuModel.id = Date.now();
    modelTemp.data.push(menuModel);
    onUpdate(modelTemp);
  };
  const removeItemChildren = (i: number) => {
    let modelTemp = { ...currentModel };
    modelTemp.data.splice(i, 1);
    onUpdate(modelTemp);
  };
  const onUpdateItemChildren = (i: number, menuObj: IMenuSettingModel) => {
    let modelTemp = { ...currentModel };
    modelTemp.data[i] = menuObj;
    onUpdate(modelTemp);
  };
  const onUpdateItem = (menuObj: IMenuSettingModel) => {
    let modelTemp = { ...currentModel };
    modelTemp = menuObj;
    onUpdate(modelTemp);
  };
  useEffect(() => {
    if (clientLanguages.length > 0 && !currentLanguage) {
      setCurrentLanguage(clientLanguages.find((m) => m.isDefault)?.langCode);
    }
  }, [clientLanguages]);

  useEffect(() => {
    menuItem?.data?.forEach((item, index) => {
      item.key = nanoid();
    })
    setModel({ ...menuItem });
    setCurrentModel({ ...menuItem });
  }, [menuItem]);
  return (
    <div className="menu-setting-item m-bot-1">
      <Collapse defaultActiveKey={["1"]} expandIconPosition={`right`}>
        <Panel
          header={currentModel.name}
          key="1"
          extra={genExtra(currentModel?.id ?? 0)}
        >
          <MenuSettingItemList
            menuItems={currentModel.data}
            onAdd={onAddMenuChildren}
            onChange={() => onUpdate(currentModel)}
            onRemove={removeItemChildren}
            onUpdate={onUpdateItemChildren}
          />
          <MenuSettingChildrenModal
            model={model}
            onModal={isModal}
            onSave={(model: IMenuSettingModel) => {
              isUpdate ? onUpdateItem(model) : onAddMenuChildren(model);
            }}
            closeModal={()=> setModal(false)}
            onUpdate={isUpdate}
          />
          {currentModel && currentModel.data && (
            <Sortable
              model={[...currentModel.data].map((item, index) => ({
                key: item.key,
                title: item.name,
                sort: item.sort ?? 0,
              })) as SortItemModel[]}
              onCancel={async () => {
                setIsUpdateSort(false);
              }}
              onOk={async (results) => {
                model?.data?.forEach((m, index) => {
                  let old = results.some(r => r.key === m.key);
                  if (old) {
                    m.sort = results.find(r => r.key === m.key)?.sort ?? 0;
                  }
                })
                model?.data.sort((a, b) => a.sort - b.sort);
                onUpdate({ ...model });
                setIsUpdateSort(false);
              }}
              title={`${"Sắp xếp"} ${t(CoreResource, MenuText)}`}
              visible={isUpdateSort && menuItem?.data?.length > 0}
            ></Sortable>
          )}

        </Panel>
      </Collapse>
    </div>
  );
};
